import { TileLayer } from 'react-leaflet';

const TILE_LAYER_CONFIG = {
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  url: '/carto-tiles/{z}/{x}/{y}{r}.png',
  maxZoom: 20,
} as const;

const CargoTileLayer = () => (
  <TileLayer
    attribution={TILE_LAYER_CONFIG.attribution}
    url={TILE_LAYER_CONFIG.url}
    maxZoom={TILE_LAYER_CONFIG.maxZoom}
  />
);

export default CargoTileLayer;
